import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Footer from "../Components/Footer";
import Navbar from '../Components/Navbar';
import { Helmet } from 'react-helmet';
import apiService from "../apiService";

function Subcategories() {
    const { slug } = useParams();
    const [nslug, setslugdata] = useState("");
    const [categories_data, setcategories_data] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const fallbackImages = [
        "https://images.unsplash.com/photo-1581092160607-ee22621dd758?auto=format&fit=crop&w=600&q=80",
        "https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?auto=format&fit=crop&w=600&q=80",
        "https://images.unsplash.com/photo-1560066984-138dadb4c035?auto=format&fit=crop&w=600&q=80",
        "https://images.unsplash.com/photo-1581578731548-c64695cc6952?auto=format&fit=crop&w=600&q=80",
        "https://images.unsplash.com/photo-1489987707025-afc232f7ea0f?auto=format&fit=crop&w=600&q=80"
    ];

    useEffect(() => {
        if (slug) {
            get_category_data(slug);
        }
    }, [slug]);

    const get_category_data = async (slugVal) => {
        setIsLoading(true);
        try {
            const res_data = await apiService.get_category_wise_data(slugVal);
            const mcat = res_data?.data;
            if (mcat && mcat.status === 1 && mcat["main-category"]) {
                const nnslg = mcat["main-category"];
                setslugdata(nnslg.name || slugVal);
                setcategories_data(mcat["categories"] || []);
            } else {
                setslugdata(slugVal ? slugVal.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase()) : "Subcategory");
                setcategories_data([]);
            }
        } catch (err) {
            console.error("Error loading subcategory data:", err);
            setslugdata(slugVal ? slugVal.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase()) : "Subcategory");
            setcategories_data([]);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div style={{ backgroundColor: '#ffffff', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            <Helmet>
                <title>{nslug ? `${nslug} Services | Reliep` : 'Subcategories | Reliep'}</title>
                <meta name="description" content={`Explore ${nslug} doorstep services on Reliep.`} />
            </Helmet>

            <Navbar />

            {/* HEADER HERO BANNER */}
            <section style={{
                background: 'radial-gradient(circle at 90% 10%, #fcf3fc 0%, #ffffff 70%)',
                padding: '48px 20px',
                borderBottom: '1px solid #f1e2f1'
            }}>
                <div style={{ maxWidth: '1280px', margin: '0 auto' }}>
                    {/* Breadcrumbs */}
                    <nav style={{ display: 'flex', gap: '8px', fontSize: '0.85rem', color: '#64748b', marginBottom: '16px' }}>
                        <Link to="/" style={{ color: '#850C85', textDecoration: 'none', fontWeight: 600 }}>Home</Link>
                        <span>/</span>
                        <Link to="/services" style={{ color: '#850C85', textDecoration: 'none', fontWeight: 600 }}>Categories</Link>
                        <span>/</span>
                        <span style={{ color: '#0f172a', fontWeight: 700 }}>{nslug || 'Subcategory'}</span>
                    </nav>

                    <div style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '6px',
                        background: '#fbf2fb',
                        border: '1px solid #ebd0eb',
                        padding: '4px 12px',
                        borderRadius: '9999px',
                        fontSize: '0.8rem',
                        fontWeight: 700,
                        color: '#850C85',
                        marginBottom: '12px'
                    }}>
                        <span>⚡</span>
                        <span>Expert Doorstep Booking</span>
                    </div>

                    <h1 style={{
                        fontSize: 'clamp(2rem, 4vw, 2.8rem)',
                        fontWeight: 800,
                        color: '#0f172a',
                        lineHeight: 1.2,
                        margin: '0 0 10px'
                    }}>
                        {nslug || 'Available Services'}
                    </h1>
                    <p style={{ fontSize: '1rem', color: '#64748b', margin: 0, maxWidth: '600px' }}>
                        Select a specialized service below to view verified partners, standard rate cards, and schedule appointments.
                    </p>
                </div>
            </section>

            {/* MAIN CONTENT GRID */}
            <main style={{ padding: '60px 20px', flex: 1 }}>
                <div style={{ maxWidth: '1280px', margin: '0 auto' }}>
                    {isLoading ? (
                        <div style={{ textAlign: 'center', padding: '80px 20px' }}>
                            <div style={{
                                width: '48px',
                                height: '48px',
                                border: '4px solid #f1e2f1',
                                borderTop: '4px solid #850C85',
                                borderRadius: '50%',
                                animation: 'spin 0.8s linear infinite',
                                margin: '0 auto 16px'
                            }} />
                            <p style={{ color: '#64748b', fontSize: '0.95rem' }}>Loading services...</p>
                            <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
                        </div>
                    ) : categories_data && categories_data.length > 0 ? (
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
                            gap: '24px'
                        }}>
                            {categories_data.map((dt, idx) => {
                                const imgSrc = dt.icon && dt.icon.startsWith('http')
                                    ? dt.icon
                                    : (dt.icon ? `http://127.0.0.1:8000/storage/${dt.icon}` : fallbackImages[idx % fallbackImages.length]);

                                return (
                                    <Link
                                        key={dt.id || idx}
                                        to={`/category/services/${dt.slug}`}
                                        style={{
                                            textDecoration: 'none',
                                            backgroundColor: '#ffffff',
                                            borderRadius: '16px',
                                            overflow: 'hidden',
                                            border: '1px solid #f1e2f1',
                                            boxShadow: '0 4px 16px rgba(133, 12, 133, 0.05)',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.transform = 'translateY(-6px)';
                                            e.currentTarget.style.borderColor = '#850C85';
                                            e.currentTarget.style.boxShadow = '0 16px 32px rgba(133, 12, 133, 0.12)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = 'translateY(0)';
                                            e.currentTarget.style.borderColor = '#f1e2f1';
                                            e.currentTarget.style.boxShadow = '0 4px 16px rgba(133, 12, 133, 0.05)';
                                        }}
                                    >
                                        <div style={{
                                            height: '200px',
                                            width: '100%',
                                            position: 'relative',
                                            backgroundColor: '#fbf2fb',
                                            overflow: 'hidden'
                                        }}>
                                            <img
                                                src={imgSrc}
                                                alt={dt.name}
                                                onError={(e) => {
                                                    e.currentTarget.src = fallbackImages[idx % fallbackImages.length];
                                                }}
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover',
                                                    transition: 'transform 0.4s ease'
                                                }}
                                            />
                                            {dt.price && (
                                                <div style={{
                                                    position: 'absolute',
                                                    bottom: '12px',
                                                    left: '12px',
                                                    background: 'rgba(255, 255, 255, 0.95)',
                                                    backdropFilter: 'blur(4px)',
                                                    padding: '4px 12px',
                                                    borderRadius: '8px',
                                                    fontSize: '0.8rem',
                                                    fontWeight: 800,
                                                    color: '#850C85',
                                                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                                                }}>
                                                    Starts ₹{dt.price}
                                                </div>
                                            )}
                                        </div>

                                        <div style={{ padding: '20px', flex: 1, display: 'flex', flexDirection: 'column' }}>
                                            <h3 style={{
                                                fontSize: '1.15rem',
                                                fontWeight: 700,
                                                color: '#0f172a',
                                                margin: '0 0 8px',
                                                lineHeight: 1.3
                                            }}>
                                                {dt.name}
                                            </h3>

                                            <p style={{
                                                fontSize: '0.85rem',
                                                color: '#64748b',
                                                margin: '0 0 16px',
                                                lineHeight: 1.5,
                                                flex: 1
                                            }}>
                                                {dt.description || 'Verified technician dispatch with standard warranty and upfront estimates.'}
                                            </p>

                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                paddingTop: '12px',
                                                borderTop: '1px solid #f8eef8'
                                            }}>
                                                <span style={{ fontSize: '0.85rem', fontWeight: 700, color: '#850C85' }}>
                                                    Book Now →
                                                </span>
                                                <div style={{
                                                    width: '32px',
                                                    height: '32px',
                                                    borderRadius: '50%',
                                                    background: '#fbf2fb',
                                                    color: '#850C85',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    fontWeight: 'bold'
                                                }}>
                                                    ›
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                );
                            })}
                        </div>
                    ) : (
                        <div style={{
                            textAlign: 'center',
                            padding: '60px 20px',
                            background: '#faf8fa',
                            borderRadius: '20px',
                            border: '1.5px dashed #ebd0eb',
                            maxWidth: '560px',
                            margin: '0 auto'
                        }}>
                            <div style={{
                                width: '72px',
                                height: '72px',
                                borderRadius: '50%',
                                background: '#fbf2fb',
                                color: '#850C85',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '2rem',
                                margin: '0 auto 16px'
                            }}>
                                🛠️
                            </div>
                            <h2 style={{ fontSize: '1.4rem', fontWeight: 800, color: '#0f172a', marginBottom: '8px' }}>
                                No Services Found
                            </h2>
                            <p style={{ fontSize: '0.92rem', color: '#64748b', marginBottom: '24px', lineHeight: 1.5 }}>
                                This subcategory does not have active listings in your area yet. Browse all our available services!
                            </p>
                            <Link
                                to="/services"
                                style={{
                                    display: 'inline-block',
                                    background: '#850C85',
                                    color: '#ffffff',
                                    padding: '12px 28px',
                                    borderRadius: '12px',
                                    fontWeight: 700,
                                    fontSize: '0.92rem',
                                    textDecoration: 'none',
                                    boxShadow: '0 4px 14px rgba(133, 12, 133, 0.25)'
                                }}
                            >
                                Browse All Services
                            </Link>
                        </div>
                    )}
                </div>
            </main>

            <Footer />
        </div>
    );
}

export default Subcategories;
